<template>
  <div class="login">
    <Login @update-user="$emit('update-user')" />
  </div>
</template>

<script>
// @ is an alias to /src
import Login from '@/components/LoginLanding.vue'

export default {
  name: 'home',
  components: {
    Login
  }
}
</script>
<style lang="scss" scoped>
.login {
  text-align: center;
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  z-index: 3;
}
</style>